import { LocalNetwork } from "@marta/common-utils";

import localhost from "../localhost";
import { FamilyAppEnvVariables } from "../types";

import googleClientId from "./googleClientId";

const env: FamilyAppEnvVariables = {
  api: {
    //
    url: LocalNetwork.MonoService,
    origin: `${localhost}:3006`,
  },
  services: {
    //
    translations: LocalNetwork.TranslationService,
    search: LocalNetwork.SearchService,
    auth: LocalNetwork.AuthService,
    communication: LocalNetwork.CommunicationService,
    document: LocalNetwork.DocumentService,
    lead: LocalNetwork.LeadService,
    appconfig: LocalNetwork.AppconfigService,
    invoicing: LocalNetwork.InvoicingService,
    caregiver: LocalNetwork.CaregiverService,
    contracting: LocalNetwork.ContractingService,
  },
  apple: {
    //
    clientId: "com.marta.family.dev",
  },
  google: {
    //
    clientId: googleClientId,
  },
  rudderstack: {
    //
    writeKey: "2R6M9S2DKN5v5zoy7NnJ0A6Etzi",
    dataPlaneUrl: "https://martaanalhqwm.dataplane.rudderstack.com",
  },
  encryption: {
    encryptionPassphrase: "djCKnDFBoQ011YBJLQfY@2!@!",
    encryptionSalt:
      "0vkGA5yAWc3t8rzWDvO3dt1DlPBq3vQ43D63BFD981BDA9DAE92EBDBE61716F22",
  },
};

export default env;
